import Background from 'Components/Reusable/Background/Background';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import React, { Fragment, useEffect,useState } from 'react';
import { information } from 'Utils/information';
import cognitive from 'Assets/img/svg/Backgrounds/cognitive/cognitive.svg';
import inActiveBig from 'Assets/img/svg/budges/inActiveBig.svg';
import { getMilestoneById, saveMilestone } from 'ReduxStore/milestones/Action';
import { RootState } from 'ReduxStore/store';
import { useParams,useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Routes } from 'Utils/Route';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { useStyles } from 'Components/Reusable/Cards/cards.style';
import Archived from 'Components/milestones/Archived'
import CustomModal from 'Components/Modals/CustomModal';
//  ./cards.style
interface RouteParams {
	id: string;
}
const Checkouts = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const params = useParams<RouteParams>();
	const classes = useStyles({ });
	const [show,setShow] = useState(false);
	const [selected,showSelected] = useState('1 week ago')
	const handleSelected = (values:string) => {
		showSelected(values)
		
		if (values === '1 week ago' ){
			//eslint-disable-next-line
			console.log(selected)
			//Get today's date using the JavaScript Date object.
			const ourDate = new Date();

			//Change it so that it is 7 days in the past.
			const pastDate = ourDate.getDate() - 7;
			// saveMilestone(params.id,pastDate)(dispatch)
		} else if (values === '1 week ago'){
			//eslint-disable-next-line
			console.log(selected)

		} else if (values === '1 week ago'){
			//eslint-disable-next-line
			console.log(selected)

		}
	}
	const handleOpen = () => {
		show===true ? setShow(false): setShow(true)
		// setShow(true)
	}
	const handleClose = () => {
		setShow(false)
	}
	const onModalClick = () => {
		history.push(Routes.Temp)
	}
	useEffect(() => {
		dispatch(getMilestoneById(params.id));
	}, []);

	const milestone = useSelector((state: RootState) => state.milestones.milestoneItem);
	return (
		<Fragment>
			<Background backgroundColor="#FEDA37" height="100vh" >
				<OverlapCard
					image={cognitive}
					heading={milestone?.title}
					information={information.checkout.info}
					common={{ margin: '-5rem auto 2rem', width: '80%' }}
					upper
					rounded
				>
					<div className="d-flex justify-content-center my-3">
						<img src={inActiveBig} alt="" />
					</div>
					<div className="d-flex justify-content-center my-3">
						<CommonButton
								command="Achieved"
								onClick={handleOpen}
								common={{
									width: 'inherit',
									height: '48px',
									background: 'white',
									radius: '200px',
									margin: '2rem 0',
									color: '#78393D',
								}}
							/>
						</div>
						{
							show ? 
							(
								<CustomModal open={show} handleClose={handleSelected}>
										<Archived />
									</CustomModal>
							)
							 : ''
						}
				</OverlapCard>
				
			</Background>
		</Fragment>
	);
};

export default Checkouts;
